import { useState } from "react";
import { Check, Feather, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function PolishPanel({ poem, dirty, save, reload }) {
  const [focus, setFocus] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (dirty && !(await save(true))) return;
    setBusy(true);
    try { const { data } = await api.post(`/poems/${poem.id}/polish`, { focus }); toast.success(data.suggestions.length ? `${data.suggestions.length} suggestions` : "No changes suggested — it reads well"); reload(); } catch (e) { if (!e.cancelled) toast.error(errMsg(e)); }
    setBusy(false);
  };
  const decide = async (sid, action) => { if (dirty && !(await save(true))) return; try { await api.post(`/poems/${poem.id}/suggestions/${sid}`, { action }); reload(); } catch (e) { toast.error(errMsg(e)); } };
  const pending = (poem.suggestions || []).filter((s) => s.status === "pending");
  return (
    <div className="panel p-4 space-y-3" data-testid="poem-polish">
      <p className="eyebrow flex items-center gap-1"><Feather size={12} />AI polish · keeps your voice</p>
      <p className="text-xs text-slate-500">Suggests small line edits only. Nothing changes until you accept a suggestion.</p>
      <div className="flex gap-2"><Input value={focus} onChange={(e) => setFocus(e.target.value)} placeholder="Focus (optional) — e.g. smoother rhythm in stanza 2" maxLength={300} className="h-9 text-sm" data-testid="poem-polish-focus" />
        <Button size="sm" onClick={run} disabled={busy} className="h-9 bg-amber-600" data-testid="poem-polish-run">{busy ? "Reading…" : "Suggest edits"}</Button></div>
      {poem.polish_overall && <p className="text-xs text-slate-300 italic" data-testid="poem-polish-overall">{poem.polish_overall}</p>}
      {pending.map((s) => (
        <div key={s.id} className="border border-slate-800 rounded-md p-3 space-y-1" data-testid={`suggestion-${s.id}`}>
          <p className="text-[10px] text-slate-500">Line {s.line}{s.reason ? ` · ${s.reason}` : ""}</p>
          <p className="text-sm text-slate-500 line-through font-serif">{s.original.trim()}</p>
          <p className="text-sm text-emerald-200 font-serif">{s.suggestion}</p>
          <div className="flex gap-2 pt-1">
            <button onClick={() => decide(s.id, "accept")} className="text-xs inline-flex items-center gap-1 text-emerald-300 hover:text-white" data-testid={`suggestion-accept-${s.id}`}><Check size={12} />Accept</button>
            <button onClick={() => decide(s.id, "reject")} className="text-xs inline-flex items-center gap-1 text-slate-400 hover:text-white" data-testid={`suggestion-reject-${s.id}`}><X size={12} />Keep mine</button>
          </div>
        </div>
      ))}
    </div>
  );
}
